var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-echart"},[_c('pip-role',_vm._b({},'pip-role',_vm.$attrs,false)),_c('pip-role-level',_vm._b({},'pip-role-level',_vm.$attrs,false)),_c('pip-active',_vm._b({},'pip-active',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }